import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'maxlenMessage'
})
export class MaxLenMessagePipe implements PipeTransform {

    transform(value: unknown, max: number): unknown {
        return `${value}不能超过${max}个字符`
    }

}
